import React, { useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Layout from "../Layout/Layout";
import DynamicPageRenderer from "../pageInside/exeemple_page/DynamicPageRenderer";
import useDataLoader from "../pageInside/exeemple_page/DataLoader";
import { elakayAutoText } from "../pageInside/dataElakay";

const PAGE_ID = "INVESTMENT_DETAIL";

const InvestmentDetail = ({ infoSource, laguangeElakay, homeStyles, nbrArr }) => {
  const { slug } = useParams();
  const lastLoadedSlugRef = useRef(null);

  const {
    pageData,
    loading,
    loadPageData,
    reloadFacets,
  } = useDataLoader({
    pageId: PAGE_ID,
    infoSource,
    token: infoSource?.token,
    investmentSlug: slug,
  });

  useEffect(() => {
    if (lastLoadedSlugRef.current === slug) return;
    lastLoadedSlugRef.current = slug;
    loadPageData({ force: true });
  }, [loadPageData, slug]);

  return (
    <Layout
      infoSource={infoSource}
      loading={loading && !pageData?.investmentProject}
      SliderPunShow={false}
      outOffPage={false}
      showFilterMenu={false}
      enableBodyParticles={false}
      enableFloatingSquares={false}
    >
      <div style={{ ...infoSource?.styleNav, paddingTop: 90 }}>
        <Link
          to="/investments"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            margin: "0 0 16px 16px",
            padding: "8px 16px",
            borderRadius: 8,
            background: "#007399",
            color: "#ffffff",
            fontSize: 13,
            fontWeight: 700,
            textDecoration: "none",
          }}
        >
          <ArrowLeft size={16} />
          {elakayAutoText("h_back_to_investments", "Retour aux investissements")}
        </Link>
        <DynamicPageRenderer
          pageId={PAGE_ID}
          pageData={pageData}
          infoSource={infoSource}
          laguangeElakay={laguangeElakay}
          homeStyles={homeStyles}
          nbrArr={nbrArr}
          reloadFacets={reloadFacets}
        />
      </div>
    </Layout>
  );
};

export default InvestmentDetail;
